export default {
  LOAD_CURRENT_USER (state, payload) {
    state.userObj = payload
  },
  LOAD_DB (state, payload) {
    state.database = payload
  },
  LOAD_TEMP_USER_FLAG (state, payload) {
    state.tempUser = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/login/vuex/mutations.js